<template>
  <div class="calendar">
    <div class="label-date-wrapper">
        <div class="left-arrow" @click="subMonth">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g id="chevron-left">
              <path id="Icon" d="M12.5 15L7.5 10L12.5 5" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>
        </div>
        <div class="current-month">
          {{ this.currentMonth.format('MMMM YYYY') }}
        </div>
        <div class="right-arrow" @click="addMonth">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g id="chevron-right">
              <path id="Icon" d="M7.5 15L12.5 10L7.5 5" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>
        </div>
    </div>
    <div class="selected-date-wrapper">
      <date-label :text="getSelectedStartDate ? getSelectedStartDate.format('DD.MM.YYYY') : '11.12.23'" :isActive="getSelectedStartDate"/>
      <div class="divider"> – </div>
      <date-label :text="getSelectedEndDate ? getSelectedEndDate.format('DD.MM.YYYY') : '11.12.23'" :isActive="getSelectedEndDate"/>
    </div>
    <div class="days">
      <div class="days-row">
        <div class="week-day"> Пн </div>
        <div class="week-day"> Вт </div>
        <div class="week-day"> Ср </div>
        <div class="week-day"> Чт </div>
        <div class="week-day"> Пт </div>
        <div class="week-day"> Сб </div>
        <div class="week-day"> Вс </div>
      </div>
      <div class="days-row">
        <day v-for="day in daysInMonth"
          :key="day.toString()"
          :text="day.format('D')"
          :isActive="day.isSame(currentMonth, 'month') && day.isSameOrAfter(new Date(), 'day') && !$store.state.availableDates.includes(day.format('YYYY-MM-DD'))"
          :isStart="day.isSame(getSelectedStartDate) && day.isSame(currentMonth, 'month')"
          :isEnd="day.isSame(getSelectedEndDate) && day.isSame(currentMonth, 'month')"
          :isRange="day.isBetween(getSelectedStartDate, getSelectedEndDate, null, '[]') && day.isSame(currentMonth, 'month')"
          @daySelected="onDaySelected(day)">
        </day>

      </div>

    </div>
    <div class="time-wrapper">

      <time-select></time-select>
    </div>
  </div>
</template>

<script>
import DateLabel from './DateLabel.vue'
import Day from './Day.vue'
import TimeSelect from './TimeSelectLayout.vue'
import moment from 'moment'

export default {
  components: { DateLabel, Day, TimeSelect },
  data () {
    return {
      currentMonth: moment().locale('ru'),
      selectedStartDate: null,
      selectedEndDate: null
    }
  },
  name: 'Calendar',
  computed: {

    daysInMonth () {
      let days = []
      let startOfMonth = this.currentMonth.clone().startOf('month').startOf('isoWeek')
      let endOfMonth = this.currentMonth.clone().endOf('month').endOf('isoWeek').subtract(1, 'day')

      let date = startOfMonth.subtract(1, 'day').clone()

      while (date.isBefore(endOfMonth, 'day')) {
        days.push(date.add(1, 'day').clone())
      }

      days.push(date.add(1, 'day').clone())

      return days
    },
    getSelectedStartDate () {
      return this.$store.state.selectedStartDate
    },
    getSelectedEndDate () {
      return this.$store.state.selectedEndDate
    }
  },
  methods: {

    addMonth () {
      let nextMonth = this.currentMonth.clone().add(1, 'month')
      if (nextMonth.isSame(new Date(), 'year')) {
        this.currentMonth = nextMonth
      }
    },
    subMonth () {
      let prevMonth = this.currentMonth.clone().subtract(1, 'month')
      if (prevMonth.isSameOrAfter(new Date(), 'month')) {
        this.currentMonth = prevMonth
      }
    },
    onDaySelected (day) {
      // Check if the day is in the unavailable dates list
      const formattedDate = day.format('YYYY-MM-DD');
      const isUnavailableDate = this.$store.state.availableDates.includes(formattedDate);

      // Only proceed if the date is not in the unavailable list or if we're deselecting a date
      if (isUnavailableDate &&
        !(day.isSame(this.getSelectedStartDate) || day.isSame(this.getSelectedEndDate))) {
        return; // Exit the function if the date is in the unavailable list
      }

      if (day.isSame(this.getSelectedStartDate) || day.isSame(this.getSelectedEndDate)) {
        this.$store.dispatch('selectStartDate', null)
        this.$store.dispatch('selectEndDate', null)
      } else {
        // change range
        if (this.getSelectedStartDate && this.getSelectedEndDate) {
          if (day.isBefore(this.getSelectedStartDate)) {
            // Check if there are unavailable dates between day and getSelectedEndDate
            if (this.hasUnavailableDatesInRange(day, this.getSelectedEndDate)) {
              return; // Don't allow selection if there are unavailable dates in the range
            }
            this.$store.dispatch('selectStartDate', day.clone())
          } else if (day.isBetween(this.getSelectedStartDate, this.getSelectedEndDate)) {
            this.$store.dispatch('selectStartDate', day.clone())
          } else {
            // Check if there are unavailable dates between getSelectedStartDate and day
            if (this.hasUnavailableDatesInRange(this.getSelectedStartDate, day)) {
              return; // Don't allow selection if there are unavailable dates in the range
            }
            this.$store.dispatch('selectEndDate', day.clone())
          }
          // set date end
        } else if (this.getSelectedStartDate) {
          // When setting end date, check if there are unavailable dates in the range
          if (this.getSelectedStartDate.isBefore(day)) {
            // Check if there are unavailable dates between getSelectedStartDate and day
            if (this.hasUnavailableDatesInRange(this.getSelectedStartDate, day)) {
              return; // Don't allow selection if there are unavailable dates in the range
            }
            this.$store.dispatch('selectEndDate', day.clone())
          } else {
            // Check if there are unavailable dates between day and getSelectedStartDate
            if (this.hasUnavailableDatesInRange(day, this.getSelectedStartDate)) {
              return; // Don't allow selection if there are unavailable dates in the range
            }
            this.$store.dispatch('selectEndDate', this.getSelectedStartDate.clone())
            this.$store.dispatch('selectStartDate', day.clone())
          }
          // set date start
        } else {
          this.$store.dispatch('selectStartDate', day.clone())
        }
      }

      this.$store.dispatch('fetchAvailablePlaces')
    },

// Add this new helper method to check for unavailable dates in a range
    hasUnavailableDatesInRange(startDate, endDate) {
      // Clone the start date to avoid modifying it
      let currentDate = startDate.clone();

      // Check each day in the range
      while (currentDate.isSameOrBefore(endDate, 'day')) {
        const formattedDate = currentDate.format('YYYY-MM-DD');
        if (this.$store.state.availableDates.includes(formattedDate)) {
          return true; // Found an unavailable date in the range
        }
        currentDate.add(1, 'day');
      }

      return false; // No unavailable dates in the range
    }
  }
}
</script>

<style>
.calendar {
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
  max-width: 320px;
}

.label-date-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
}

.left-arrow, .right-arrow {
  display: flex;
  padding: 10px;
  cursor: pointer;
}

.current-month {
  color: #101828;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  user-select: none;
}

.divider {
  color: rgba(52, 64, 84, 0.20);
  font-size: 16px;
}

.selected-date-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #F1F1F2;
}

.days {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.week-day {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  padding: 10px 10px;
}

.days-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.time-wrapper {
  padding-top: 12px;
  display: flex;
  justify-content: center;
}

@media (max-width: 1360px) {
  .week-day {
    padding: 9px;
  }
}

@media (max-width: 1305px) {
  .week-day {
    padding: 8px;
  }
}

@media (max-width: 1250px) {
  .week-day {
    padding: 7px;
    font-size: 15px;
  }
}

@media (max-width: 1195px) {
  .week-day {
    padding: 6px;
  }
}

@media (max-width: 1050px) {
  .week-day {
    font-size: 16px;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/Calendar.vue